export const LOGIN_REQUEST_PENDING = 'LOGIN_REQUEST_PENDING';
export const LOGIN_REQUEST_SUCCESS = 'LOGIN_REQUEST_SUCCESS';
export const LOGIN_REQUEST_FAILED = 'LOGIN_REQUEST_FAILED';

export const LOGOUT="LOGOUT"

export const SIGNUP_REQUEST_PENDING = 'SIGNUP_REQUEST_PENDING';
export const SIGNUP_REQUEST_SUCCESS = 'SIGNUP_REQUEST_SUCCESS';
export const SIGNUP_REQUEST_FAILED = 'SIGNUP_REQUEST_FAILED';

export const GET_PRODUCT_PENDING = 'GET_PRODUCT_PENDING';
export const GET_PRODUCT_SUCCESS = 'GET_PRODUCT_SUCCESS';
export const GET_PRODUCT_FAILED = 'GET_PRODUCT_FAILED';

export const GET_CART_PENDING="GET_CART_PENDING";
export const GET_CART_SUCCESS="GET_CART_SUCCESS";
export const GET_CART_FAILED="GET_CART_FAILED";


export const GET_WISHLIST_PENDING="GET_WISHLIST_PENDING";
export const GET_WISHLIST_SUCCESS="GET_WISHLIST_SUCCESS";
export const GET_WISHLIST_FAILED="GET_WISHLIST_FAILED";


export const ADD_CART_PENDING="ADD_CART_PENDING";
export const ADD_CART_SUCCESS="ADD_CART_SUCCESS";
export const ADD_CART_FAILED="ADD_CART_FAILED";


export const ADD_WISHLIST_PENDING="ADD_WISHLIST_PENDING";
export const ADD_WISHLIST_SUCCESS="ADD_WISHLIST_SUCCESS";
export const ADD_WISHLIST_FAILED="ADD_WISHLIST_FAILED";

export const CLEAR_CART= "CLEAR_CART";